import axios from "axios";
import {detailServicesPath} from "../../../Constants";

const detailControllerRestUrl = detailServicesPath + '/customers/orders/'


export default class QuarterControllerService {
    static async add(orderId, detailId, sideStartPointId, data) {
        const params = orderId === 0 ? "&sample=true" : ""
        return await axios.post(`${detailControllerRestUrl}${orderId}/details/${detailId}/quarters?sideStartPointId=${sideStartPointId}${params}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(orderId, detailId, quarterId) {
        const params = orderId === 0 ? "?sample=true" : ""
        return await axios.delete(`${detailControllerRestUrl}${orderId}/details/${detailId}/quarters/${quarterId}${params}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async put(orderId, detailId, quarterId, sideStartPointId, data) {
        const params = orderId === 0 ? "&sample=true" : ""
        return await axios.put(`${detailControllerRestUrl}${orderId}/details/${detailId}/quarters/${quarterId}?sideStartPointId=${sideStartPointId}${params}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}